import type {
  AddressComponent,
  AddressType,
  PlaceDetailsResponse,
  PlacePrediction,
} from '@/types/address';
import { apiClient } from './ApiClient';

export const PlaceService = {
  getPlacePredictions: async (input: string): Promise<PlacePrediction[]> => {
    try {
      const response = await apiClient.get(
        `/places/autocomplete?input=${encodeURIComponent(input)}`,
      );
      return response.data.predictions;
    } catch (error) {
      console.error('Error fetching place predictions:', error);
      return [];
    }
  },

  getPlaceDetails: async (placeId: string): Promise<AddressType | null> => {
    try {
      const { data } = await apiClient.get<PlaceDetailsResponse>(
        `/places/details?placeId=${encodeURIComponent(placeId)}&fields=address_components,formatted_address,geometry`,
      );
      console.log(data);
      const place = data.result;
      const addressComponents = place.address_components;

      let address1 = '';
      let address2 = '';
      let city = '';
      let region = '';
      let postalCode = '';
      let country = '';

      for (const component of addressComponents) {
        const types = component.types;

        if (types.includes('street_number')) {
          address1 = component.long_name;
        } else if (types.includes('route')) {
          address1 = `${address1} ${component.long_name}`.trim();
        } else if (types.includes('subpremise')) {
          address2 = component.long_name;
        } else if (types.includes('locality')) {
          city = component.long_name;
        } else if (types.includes('administrative_area_level_1')) {
          region = component.short_name;
        } else if (types.includes('postal_code')) {
          postalCode = component.long_name;
        } else if (types.includes('country')) {
          country = component.long_name;
        }
      }
      return {
        address1,
        address2,
        formattedAddress: place.formatted_address,
        city,
        region,
        postalCode,
        country,
        lat: place.geometry.location.lat,
        lng: place.geometry.location.lng,
      };
    } catch (error) {
      console.error('Error fetching place details:', error);
      return null;
    }
  },

  getStaticMapUrl: async (
    address: string,
    size = '400x300',
    zoom = '15',
    maptype = 'roadmap',
  ): Promise<string | null> => {
    try {
      const response = await apiClient.get(
        `/places/static-map-url?address=${encodeURIComponent(address)}&size=${size}&zoom=${zoom}&maptype=${maptype}`,
      );
      return response.data.url;
    } catch (error) {
      console.error('Error fetching static map URL:', error);
      return null;
    }
  },
};
